<script setup lang="ts">
import {computed} from 'vue';
import {useMoods, MOOD_FACE_YELLOW} from '@/ts/composables/pure/use-moods';
import type {MoodDTO} from '@/ts/types/dto/journals-dto';

const props = withDefaults(defineProps<{
  mood: MoodDTO;
  size?: number;
  /** Tinted face for the picker; the yellow base face is used on entry cards. */
  tinted?: boolean;
}>(), {
  size: 38,
  tinted: false,
});

const {getMood} = useMoods();

const visual = computed(() => getMood(props.mood));
const faceColor = computed(() => (props.tinted ? visual.value?.tint ?? MOOD_FACE_YELLOW : MOOD_FACE_YELLOW));
const features = computed(() => `${visual.value?.eyes ?? ''}${visual.value?.mouth ?? ''}`);
</script>

<template>
  <svg
    v-if="visual"
    class="mood-face"
    :width="size"
    :height="size"
    viewBox="0 0 38 38"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="19" cy="19" r="19" :fill="faceColor"/>
    <!-- eslint-disable-next-line vue/no-v-html -- static path data from use-moods, no user input -->
    <g v-html="features"/>
  </svg>
</template>

<style scoped lang="scss">
.mood-face {
  display: block;
  border-radius: 100px;
  flex: 0 0 auto;
}
</style>
